// Helpers purs des onglets de fiche (testables sans DOM).

export function readTabFromHash(hash, tabIds = [], fallback = null) {
  const id = String(hash || "").replace(/^#/, "");
  return tabIds.includes(id) ? id : fallback;
}

export function writeTabToHash(id) {
  try {
    window.history.replaceState(window.history.state, "", `#${id}`);
  } catch (e) {
    // navigation privée / environnement sans history : on ignore
  }
}

// Onglet effectivement affiché : l'onglet demandé s'il est visible, sinon le
// premier visible (un onglet masqué par rôle ou par données ne doit jamais
// exposer son contenu).
export function resolveActiveTab(requestedId, visibleTabs = []) {
  if (!visibleTabs.length) return null;
  return visibleTabs.some((t) => t.id === requestedId) ? requestedId : visibleTabs[0].id;
}

export function nextTabId(currentId, visibleTabs = [], delta) {
  const ids = visibleTabs.map((t) => t.id);
  const index = ids.indexOf(currentId);
  if (index === -1) return ids[0] || null;
  return ids[(index + delta + ids.length) % ids.length];
}

// Copie presse-papier avec repli (execCommand) pour les navigateurs sans
// navigator.clipboard ou hors contexte sécurisé.
export function copyToClipboard(value) {
  const text = value === undefined || value === null ? "" : String(value);
  if (typeof navigator !== "undefined" && navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch(() => legacyCopy(text));
  }
  return legacyCopy(text);
}

function legacyCopy(text) {
  return new Promise((resolve, reject) => {
    try {
      const area = document.createElement("textarea");
      area.value = text;
      area.setAttribute("readonly", "");
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      const ok = document.execCommand && document.execCommand("copy");
      document.body.removeChild(area);
      ok ? resolve() : reject(new Error("copy failed"));
    } catch (e) {
      reject(e);
    }
  });
}
